/**
 * @module cercaliagl/view/VZBEPopup
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import $ from 'jquery';
import BaseView from './BaseView';
import { i18n } from '../dictionary';
/**
 * @typedef {Object} ZBEInfo
 * @property {number} [id]
 * @property {string} [a8_name]
 * @property {string} [info]
 * @property {string} [zbe_name]
 */
/**
 * @classdesc
 */
var VZBEPopup = /** @class */ (function (_super) {
    __extends(VZBEPopup, _super);
    /**
     * @constructor
     */
    function VZBEPopup() {
        var _this = this;
        var jqElement = $('<div class="v-zbepopup mdc-elevation--z4"></div>');
        _this = _super.call(this, jqElement) || this;
        /**
         * @private
         * @type {ZBEInfo}
         */
        _this.info_ = null;
        return _this;
    }
    /**
     * @private
     */
    VZBEPopup.prototype.render_ = function () {
        var html = "\n    <div class=\"header\">\n      <span>".concat(this.info_.zbe_name, "</span>\n    </div>\n    <div class=\"zbe-content\">\n      <div class=\"address\">\n        <a target=_blank class=\"zbe-link\" href=").concat(this.info_.info, ">\n        ").concat(this.info_ ? "".concat(i18n('ZBEInfo'), "<br/>") : '', "\n        </a>\n      </div>\n    </div>\n    <div class=\"actions\">\n      <button type=\"button\" class=\"mdc-button ok\"><span class=\"mdc-button__ripple\"></span>OK</button>\n    </div>");
        this.jqElement_
            .empty()
            .append(html);
        this.show();
        this.initialize_();
    };
    /**
     * @private
     */
    VZBEPopup.prototype.initialize_ = function () {
        var _this = this;
        this.jqElement_.find('button.ok').click(function () { return _this.hide(); });
    };
    /**
     * @param {ZBEInfo} info ZBE Info
     */
    VZBEPopup.prototype.update = function (info) {
        this.info_ = info;
        this.render_();
    };
    return VZBEPopup;
}(BaseView));
export default VZBEPopup;
//# sourceMappingURL=VZBEPopup.js.map